import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const GetPropertyFmlsSearch = createAsyncThunk(
  "Listings/GetPropertyFmlsSearch",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/search/getPropertiesBySearchParams/1`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(resp.data,"resp.data")
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

